import { LinkedChainNavigation } from 'components/linkedChainNavigation/linkedChainNavigation'
import { push } from 'connected-react-router'
import { delay, put, select } from 'redux-saga/effects'
import { RootState } from 'stores'

export function* moveToNextScreen() {
  yield delay(300)
  const currentPath = yield select(
    (state: RootState) => state.router.location.pathname
  )
  const linkedChainNavigation = new LinkedChainNavigation(currentPath)
  if (linkedChainNavigation.next) {
    yield put(push(linkedChainNavigation.next))
  }
}
